import { useFieldStyles, useLeadField } from '#modules/LeadGeneration/hooks/field';
import { Box, Typography } from '@material-ui/core';
import * as React from 'react';
import { TimePickerFieldProps } from './model';
import { TimeTextField } from './TimeTextField';

export const TimePickerField = ({ field, handleChangeFields }: TimePickerFieldProps) => {
  const [{ value }, { error, touched }, { setValue }] = useLeadField(field);
  const { stylesLabel } = useFieldStyles();

  return (
    <React.Fragment>
      <Box display='flex' alignItems='center' justifyContent='space-between'>
        <Typography variant='subtitle2' className={stylesLabel}>
          {field.title}
        </Typography>
      </Box>
      <TimeTextField
        error={Boolean(error && touched)}
        value={value}
        onChange={(value: string) => {
          setValue(value);
          handleChangeFields(field.type, value);
        }}
        placeholder={field.placeholderText}
      />
      {error && touched && (
        <Typography variant='subtitle2' color='error'>
          {error}
        </Typography>
      )}
    </React.Fragment>
  );
};
